export const APPROVAL_REQUEST_API_PATHS = {
  LIST: "v1/approval-requests/",
  ASSIGNED: "v1/approval-requests/assigned/",
  DETAIL: "v1/approval-requests/{0}/",
  ACTION: "v1/approval-requests/{0}/action/",
  OVERRIDE: "v1/approval-requests/{0}/override/",
  CANCEL: "v1/approval-requests/{0}/cancel/",
};

export const APPROVAL_REQUEST_STATUSES = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  SKIPPED: "SKIPPED",
  UNRESOLVED: "UNRESOLVED",
  WAITING: "WAITING",
} as const;

export const APPROVAL_REQUEST_STATUS_LABELS: Record<
  (typeof APPROVAL_REQUEST_STATUSES)[keyof typeof APPROVAL_REQUEST_STATUSES],
  string
> = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
  SKIPPED: "Skipped",
  UNRESOLVED: "Unresolved",
  WAITING: "Waiting",
};

export const APPROVAL_REQUEST_STATUS_MAPPING: Record<
  string,
  "success" | "warning" | "info" | "error" | "default"
> = {
  PENDING: "warning",
  APPROVED: "success",
  REJECTED: "error",
  CANCELLED: "error",
  EXPIRED: "error",
  SKIPPED: "info",
  UNRESOLVED: "warning",
  WAITING: "warning",
};

export const ASSIGNMENT_STATUSES = {
  ALL: "ALL",
  ACTION_REQUIRED: "ACTION_REQUIRED",
  ACTED: "ACTED",
} as const;

export const LIST_SCOPES = {
  ASSIGNED: "assigned",
  ALL: "all",
} as const;
